"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _TooltipContainerStyled = require("../styled/TooltipContainerStyled");
/**
 * This component is mostly for presentation, and is exposed to our consumers in case they want to
 * use these styles in their own components. Generally, that has taken the form of a custom Flyout
 * so it can have interactive elements inside of it.
 */
const TooltipContainer = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    squareCorner = undefined,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_TooltipContainerStyled.TooltipContainerStyled, (0, _extends2.default)({}, rest, {
    squareCorner: squareCorner,
    themeMode: themeMode,
    ref: ref
  }), children);
});
exports.TooltipContainer = TooltipContainer;
TooltipContainer.displayName = "TooltipContainer";
//# sourceMappingURL=TooltipContainer.js.map